/* eslint-disable react/prop-types */
import * as React from 'react';

import { List } from 'antd';

import { cn } from 'utils';

function PrimitiveList<T>({
  size = 'large',
  loading,
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof List<T>>) {
  const loadingConfig: typeof loading =
    typeof loading === 'boolean'
      ? loading
      : loading
        ? {
            wrapperClassName: 'min-h-48',
            ...loading,
          }
        : undefined;

  return (
    <List<T>
      size={size}
      loading={loadingConfig}
      className={cn('[&_li]:border-solid [&_li]:border-[inherit]', className)}
      {...props}
    />
  );
}

const PrimitiveListItem = React.forwardRef<
  React.ElementRef<typeof List.Item>,
  React.ComponentPropsWithoutRef<typeof List.Item>
>(({ className, ...props }, ref) => (
  <List.Item
    ref={ref}
    className={cn('overflow-x-auto rounded border bg-white p-4', className)}
    {...props}
  />
));
PrimitiveListItem.displayName = 'PrimitiveListItem';

const PrimitiveListItemMeta = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof List.Item.Meta>) => (
  <List.Item.Meta className={cn('items-center', className)} {...props} />
);

export { PrimitiveList, PrimitiveListItem, PrimitiveListItemMeta };
